module.exports = __webpack_public_path__ + "img/defaultVoucherIco.a3d3d8f4.png";